import { useRouter } from 'next/router';

import { BUSINESS_PATH, DEVICE_GALLERY_PAGE } from 'shared/constants';
import { useSegment } from 'shared/hooks';
import { useIsWebView as useIsAppView } from 'shared/providers/isWebView';

export default function useShopRouter() {
  const router = useRouter();
  const { isBusiness } = useSegment();
  const isAppView = useIsAppView();

  function chooseSegmentPage(page: string) {
    if (isBusiness) {
      return `${BUSINESS_PATH}${page}`;
    }

    return page;
  }

  function buildPath(page: string) {
    if (isAppView) {
      return chooseSegmentPage(DEVICE_GALLERY_PAGE);
    }

    return chooseSegmentPage(page);
  }

  function push(page: string) {
    const path = buildPath(page);
    router.push(path);
  }

  function replace(page: string) {
    const path = buildPath(page);
    router.replace(path);
  }

  return {
    push,
    replace,
  };
}
